import { render, staticRenderFns } from "./FeedbackAttachmentSkeleton.vue?vue&type=template&id=27e0c3b4"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports